import OddConverter from "@common/helpers/oddConverter";
import { IClientConfig } from "src/client-config/config";
import { BetTypeEnum } from "src/constants/enums/betType";
import { ISelection } from "src/constants/interfaces/bet";
import { getTotalOdd } from "../odd";
import { roundAmount } from "../helpers";
import { IPartnerConfig } from "src/constants/interfaces";

export const getMultiplePossibleWin = (
	config: IClientConfig,
	stake: number,
	selections: ISelection[],
	systemCombinationCount: number,
	partnerConfig?: IPartnerConfig
) => {
	const totalOdd = OddConverter(
		config,
		getTotalOdd(config, partnerConfig, BetTypeEnum.Multiple, selections),
		'decimal'
	);

	if (!totalOdd) return 0;

	const roundedStake = +roundAmount(stake);
	const expressOdd = Math.floor(totalOdd * 1000) / 1000;

	return Math.floor(expressOdd * roundedStake * 100000000 || 0) / 100000000;
};
